import { UISpecCategory } from '@common/enums';
import { GemRecord } from '@common/gems/types';
import { Private_Routes } from '@common/url';
import { renderColumnWithEllipsis } from '@common/utils/renderUtils';
import { WorkflowMode } from '@prophecy/graphql-types/enums';
import { theme } from '@prophecy/theme';
import { Stack } from '@prophecy/ui-v3';
import { focusVisibleRing } from '@prophecy/ui-v3/Button/styled';
import { ColumnsType } from '@prophecy/ui-v3/Table';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  ${focusVisibleRing(theme.radius.x6, 2)}
`;

export const columns: ColumnsType<GemRecord> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (name: string, record) => {
      return (
        <Stack direction='horizontal' gap={theme.spaces.x8} align='space-between'>
          <StyledLink
            to={Private_Routes.GemPlayground.getUrl(
              { category: record.category, componentId: record.path || record.name },
              {
                language: record.language,
                mode: record.mode
              }
            )}
            data-test-id={`gem-list-gem-link-${record.path || record.name}`}>
            {name}
          </StyledLink>
        </Stack>
      );
    }
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    render: (value, record) => {
      if (value === UISpecCategory.SourceTarget && record.mode === WorkflowMode.stream) {
        return `${value} (${record.mode})`;
      }
      return value;
    }
  },
  {
    title: 'Source',
    dataIndex: 'source',
    key: 'source'
  },
  {
    title: 'Team',
    dataIndex: 'team',
    key: 'team',
    render: (_text: unknown) => renderColumnWithEllipsis('eng@prophecy.io_team')
  }
];

export const airflowColumns: ColumnsType<GemRecord> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (name: string, record) => {
      return (
        <Stack direction='horizontal' gap={theme.spaces.x8} align='space-between'>
          <StyledLink
            to={Private_Routes.AirflowGemPlayground.getUrl(
              { category: record.category, componentId: name },
              {
                language: record.language
              }
            )}
            data-test-id={`gem-list-airflow-gem-link-${name}`}>
            {name}
          </StyledLink>
        </Stack>
      );
    }
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category'
  },
  {
    title: 'Source',
    dataIndex: 'source',
    key: 'source'
  }
];
